import {Swipejobs} from './Swipejobs';
import BranchDesktopBase from "../BranchDesktopBase";

export class BranchDesktopSwipejobs extends Swipejobs {
    constructor() {
        super();
    }
}

const branchDesktopSwipejobsTheme = BranchDesktopBase.setShareStyles(new BranchDesktopSwipejobs());
export default branchDesktopSwipejobsTheme;


// WEBPACK FOOTER //
// webpack://frontendThemeProvider/src/themes/Swipejobs/branch-desktop.ts